



































import Vue from 'vue'
import ModalFullScreen from '@/common/components/ModalFullScreen.vue'
import { AdditionalOption as AdditionalOptionModel } from '@/common/types'
import AdditionalOption from '@/common/components/additionalOptions/AdditionalOption.vue'
import { scrollToElement } from '@/helper'

export default Vue.extend({
  components: {
    ModalFullScreen,
    AdditionalOption
  },
  props: {
    options: {
      type: Array as () => AdditionalOptionModel[],
      required: true
    },
    selectedAdditionalOptionIds: {
      type: Array as () => string[],
      default: () => []
    }
  },
  data(): {
    currentAdditionalOptionIds: string[]
  } {
    return {
      currentAdditionalOptionIds: this.selectedAdditionalOptionIds
    }
  },
  created() {
    this.$nextTick(() =>
      scrollToElement('[class="pr-StickerOption"][aria-selected="true"]')
    )
  },
  methods: {
    updateCurrentAdditionalOptionIds(id: string) {
      if (!!this.currentAdditionalOptionIds.find(item  => item === id)) {
        this.currentAdditionalOptionIds = this.currentAdditionalOptionIds.filter(item => item !== id)
      } else {
        this.currentAdditionalOptionIds = [...this.currentAdditionalOptionIds, id]
      }
    },
    onUpdateSelectedAdditionalOptions() {
      this.$emit('update', this.currentAdditionalOptionIds)
    },
    onCloseModal() {
      this.$emit('close')
    }
  }
})
